import selector, {identitySelector} from 'utils/selector'
import published from 'utils/published'
import {Optional, Project} from 'data/types'
import APIService from './APIService'

export default class ProjectsService {
  public projects = published<Project[]>([])
  public selectedProject = published<Optional<Project>>(null)

  constructor() {
    this.loadProjects()
  }

  private loadProjects = async () => {
    if (this.projects.isLoading) {
      return
    }
    this.projects.startLoading()
    const [projectsResult, selectedProjectResult] = await Promise.all([APIService.getProjects(), APIService.getSelectedProject()])

    if (projectsResult.ok) {
      this.projects.publish(projectsResult.body)
    }

    if (this.projects.value.length === 1) {
      this.selectedProject.publish(this.projects.value[0])
    } else if (selectedProjectResult.ok) {
      this.selectedProject.publish(selectedProjectResult.body)
    }

    this.projects.endLoading()
  }
}

export const projectsServiceSelector = selector(identitySelector<string>(), () => new ProjectsService())
